import { render, staticRenderFns } from "./InstagramModal.vue?vue&type=template&id=619939da&scoped=true"
import script from "./InstagramModal.vue?vue&type=script&lang=js"
export * from "./InstagramModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619939da",
  null
  
)

export default component.exports